import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 送り先名を取得するユースケース
 * @param destination - 送り先情報
 */
export class GetSalesDestinationNameUseCase {
  private repository: IBaseBusinessManageRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessManageRepository) {
    this.repository = repository;
  }
  /**
   * 送り先名を取得する
   * @param destinationNumber - 送り先番号
   */
  async execute(destinationNumber: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getSalesDestinationName(destinationNumber);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
